export const SET_CARDS_LOADING = 'SET_CARDS_LOADING'
export const SET_DEFAULT_CARD = 'SET_DEFAULT_CARD'
export const SET_CARDS = 'SET_CARDS'

export interface SetCardsLoadingAction {
    type: typeof SET_CARDS_LOADING
    loading: boolean
    receivedAt: number
}

export interface SetDefaultCardAction {
    type: typeof SET_DEFAULT_CARD
    card: Models.Card
    receivedAt: number
}

export interface SetCardsAction {
    type: typeof SET_CARDS
    cards: Models.Card[]
    receivedAt: number
}
